import React from 'react';
import styled from 'styled-components';

import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { smallMediaQuery } from '../../../../../common/utilities/sizeHelpers';

export const SolarDivideLoadingUI = () => {
    return (
        <Container>
            <AnimatedLoadingPlaceholder height='40px' width={43} />
        </Container>
    );
};

const Container = styled.li`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 10px;
    align-items: center;
    height: 260px;
    width: 63px;
    min-width: 63px;
    @media ${smallMediaQuery} {
        flex-direction: row;
        height: 63px;
        width: 100%;
        min-width: 100%;
        padding: 4px 0;
        margin-bottom: 4px;
    }
`;